module.exports = __webpack_public_path__ + "img/providerConnectImage.a4da2837.png";